'use strict';

import {GPItem} from "./gp-item.js";


export class GPStructure extends GPItem
{
    constructor (id, typeId, x, y, scale, horizontalFlip, adjustment) {
        super();
        this.id = id;
        this.typeId = typeId;
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.horizontalFlip = horizontalFlip;
        this.zindex = 0;
        this.imageWidth = null;
        this.imageHeight = null;
        this.data = GP.structureTypesById[typeId];
        this.typeScale = this.data.scale;
        this.adjustment = adjustment;
        this.relativeBaseOffset = this.data.relativeBaseOffset ? this.data.relativeBaseOffset : 0;
        this.actualBaseOffset = 0;
        this.originItemInstance = null;
        this.fixedObject = false;

        this.supportsFlip = true;
        this.supportsInfo = false;
        this.supportsAdjust = true;
        this.supportsRotate = false;
        this.supportsThumb = true;
    }


    getPathForImage () {
        return this.data.staticGetPathForImage();
    }

    getPathForThumb () {
        return this.data.staticGetPathForThumb();
    }

    itemImageScale (projy) {
        var itemSize = this.getHeight();
        var scale = this.scaleAccordingToHorizon(projy) * 10/12;
        if (scale <=0.1) scale = 0.1;
        scale = scale*itemSize/(this.imageHeight);
        scale = scale * this.scale * this.typeScale;
        return scale;
    }
    
    toJSON() {
        let res = {
            id: this.id,
            typeId: this.typeId,
            x: this.x,
            y: this.y,
            s: this.scale,
            f: this.horizontalFlip
        }
        if (this.adjustment) res.adj = this.adjustment;
        return res;
    }

}